/**
 * Which error screen to show, as the React router did: its signed-in pages (/home and /signup) had
 * their own error screen, while unknown pages and everything else showed "not found".
 */
export function showsNotFound(status: number, pathname: string): boolean {
  return status === 404 || !/^\/(home|signup)(\/|$)/i.test(pathname);
}
